import {Backend} from '@common/backend'
import {FilePreview} from '@common/file-preview'
import {noPropagate} from '@containers/hooks'
import React from 'react'
import {UserEvent} from 'yougile-model'
import {UIUtil} from 'yougile-util'

interface Props {
  event: UserEvent
}

export const FilesPreview = ({event}: Props) => {
  return (
    event.type === 'file' && (
      <div className="flex flex-wrap">
        {event.urls.map(url => {
          const ext = url.split('?')[0].split('.').pop().toLowerCase()
          if (UIUtil.imageTypes().includes(ext)) {
            return (
              <a
                href={Backend.toDataUrl(url)}
                target="_blank"
                key={url}
                onClick={noPropagate}
                className="mt-8 mr-8"
              >
                <img
                  src={Backend.toDataUrl(FilePreview.previewFromUrl(url))}
                  width={96}
                  height={64}
                  className="bg-cover rounded-4"
                />
              </a>
            )
          }
          return null
        })}
      </div>
    )
  )
}
